import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule, MatIconModule, MatMenuModule, MatToolbarModule, MatBadgeModule, MatDialogModule, MatOptionModule, MatSelectModule } from '@angular/material';

import { FuseShortcutsModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';

import { ToolbarComponent } from 'app/layout/components/toolbar/toolbar.component';
import { SharedModule } from 'app/main/shared/shared.module';

@NgModule({
    declarations: [
        ToolbarComponent
    ],
    imports: [
        RouterModule,
        MatBadgeModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatToolbarModule,
        MatDialogModule,
        SharedModule,
        FuseSharedModule,
        FuseShortcutsModule,
        MatOptionModule,
        MatSelectModule
    ],
    exports: [
        ToolbarComponent
    ]
})
export class ToolbarModule {
}
